// extracted by mini-css-extract-plugin
export default {"crossIcon":"m6I32Txa0zGNPztSlzjo","addButton":"aLfpkiDS4tFH7pDU8TvB"};